import { useState } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';

import { useTeam, useUpdateTeam } from '../contexts/teams';
import { toPayload, validate, valuesFrom } from '../utils/form';
import TeamMembers from '../layouts/members';
import TeamFields from './fields';

import '../../clients/styles/form.css';

export default function EditTeamForm({ teamId }) {
    const { data: team, isLoading, error } = useTeam(teamId);

    if (isLoading) return <p className="client-form__loading">Cargando equipo...</p>;

    if (error) {
        return (
            <p className="client-form__failure">
                {error.message || 'No se pudo cargar el equipo'}
            </p>
        );
    }

    return <TeamEditor key={team.id} team={team} />;
}

function TeamEditor({ team }) {
    const updateTeam = useUpdateTeam(team.id);

    const [values, setValues] = useState(() => valuesFrom(team));
    const [errors, setErrors] = useState({});

    const change = (field, value) => {
        setValues(prev => ({ ...prev, [field]: value }));
        setErrors(prev => (prev[field] ? { ...prev, [field]: undefined } : prev));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const found = validate(values);
        if (Object.keys(found).length) {
            setErrors(found);
            return;
        }

        try {
            await updateTeam.mutateAsync(toPayload(values));
            toast.success('Equipo guardado');
        } catch (err) {
            if (err.fields) setErrors(err.fields);
            else toast.error(err.message || 'No se pudo guardar el equipo');
        }
    };

    return (
        <section className="client-form">
            <header className="client-form__header">
                <h2 className="client-form__title">{team.name}</h2>
                <p className="client-form__subtitle">Equipo #{team.id}</p>
            </header>

            <form onSubmit={handleSubmit} noValidate>
                <div className="client-form__card">
                    <div className="client-form__section">
                        <h3 className="client-form__section-title">Datos del equipo</h3>
                        <p className="client-form__section-text">Cómo se llama y de qué se ocupa.</p>
                    </div>

                    <TeamFields
                        values={values}
                        errors={errors}
                        onChange={change}
                        disabled={updateTeam.isPending}
                    />
                </div>

                <div className="client-form__actions">
                    <Link to="/admin/people/equipos" className="client-form__cancel">Volver</Link>
                    <button
                        type="submit"
                        className="client-form__submit"
                        disabled={updateTeam.isPending}
                    >
                        {updateTeam.isPending ? 'Guardando...' : 'Guardar cambios'}
                    </button>
                </div>
            </form>

            {/* Outside the <form> on purpose: adding or removing a member is
                its own request that lands immediately, not something the team's
                Save button confirms. Nesting it inside would also nest a form
                in a form, which the browser will not do. */}
            <div className="client-form__card client-form__card--stacked">
                <TeamMembers teamId={team.id} />
            </div>
        </section>
    );
}
